const routes = [
    {
        path: '/emissor/sistema/inicio',
        alias: ['/emissor', '/emissor/inicio'],
        component: () => import('../views/DashboardView')
    }
]

export default routes
